import * as React from 'react';
import { Container, Row, Col } from 'reactstrap';
import './NavMenu.css';

export default class NavMenu extends React.PureComponent {

    public render() {
        return (
            <section className="panel panel-banner">
                <header className="banner_content banner_content-inverted">
                    <div className="site-width">
                        <Row>
                            <Col>
                                <h1 className="banner_content_title">Your Credit Agreement</h1>
                                <h1 className="banner_content_title_mobile">Your Agreement</h1>
                            </Col>
                            </Row>
                    </div>
                </header>
            </section>
        );
    }
}
